module.exports = __webpack_public_path__ + "static/media/image-card-4.9ff0c12d.png";